import {post} from 'application/api/baseApi';

type Request = {
  prod_ID: string;
  dept_ID: string;
  subDept_ID: string;
  superSubDept_ID: string;
};

type Response = {
  status: 'SUCCESS' | 'FAILURE';
  message: string;
};

const path = '/addProdDeptMatrix';

/**
 * Middleware for {@link post | the generic API "post" function}.
 * @remark Adds type restrictions and the path parameter.
 * @param req Request body
 * @returns Expected response or null
 */
const addProductDeptAPI = (req: Request) => post<Response>(path, req);

export default addProductDeptAPI;